module.exports = __webpack_public_path__ + "img/20251210.b248e954.png";